import React from 'react';
import { ChartContainer } from '../ChartContainer';
import { useReviewTimeChart } from './hooks';

export default function ReviewTimeChart({ reviews }) {
  const { chartRef } = useReviewTimeChart(reviews);

  return (
    <ChartContainer chartRef={chartRef} />
  );
}
